import React from 'react';
import PropTypes from 'prop-types';
import emptyTableImage from './empty-state-with-robots.svg';
import './empty-insights-report.scss';

export default class EmptyInsightsReport extends React.Component {
  static propTypes = {
    header: PropTypes.string,
    content: PropTypes.string
  };

  render() {
    return (
      <div className='empty-insights-report'>
        <img
          className='empty-insights-report__image'
          role='presentation'
          src={emptyTableImage}
        />
        <div>
          <h3 className='empty-insights-report__header'>{this.props.header}</h3>
          <p className='empty-insights-report__text'>{this.props.content}</p>
        </div>
      </div>
    );
  }
}
